import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceProjectWeatherReportEditionNotificationState = createStateReducer(
  initialState,
  {
    [events.editProjectWeatherReportSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectWeatherReport",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editProjectWeatherReportFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectWeatherReport",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceProjectWeatherReportEditionNotificationState };
